import { MeetInfo } from '../types/Video';

export const fetchMeetInfo = async (meetId: string) => {
  const response = await fetch(`${process.env.REACT_APP_SIGNALLING_API_URL}/meet/${meetId}/info`);
  if (!response.ok) {
    throw new Error(`Błąd HTTP: ${response.status}`);
  }
  const data: MeetInfo = await response.json();

  const now = new Date();
  const startTime = new Date(data.startTime);
  const timeDifference = Math.abs(now.getTime() - startTime.getTime()) / 1000 / 60; // różnica w minutach

  //TODO - sprawdzenie czy spotkanie się już zaczęło
  // if (timeDifference > 5) {
  //      setTimeError("Spotkanie jeszcze się nie rozpoczęło lub już jest za późno.");
  //  } else {
  return data;
  //}
};
